var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
var SidebarLink = function (props) {
    return (_jsx(Link, __assign({}, props, { onClick: function () {
            if (document.body.classList.contains("sidebar-show")) {
                document.body.classList.remove("sidebar-show");
            }
            else {
                document.body.classList.add("sidebar-show");
            }
        }, children: props.children })));
};
export default SidebarLink;
